import { yupResolver } from '@hookform/resolvers/yup'
import { useForm } from 'react-hook-form'
import { addDriverFormSchema } from './add-driver-form.schema'

export const useAddDriverForm = () => {
  return useForm({
    resolver: yupResolver(addDriverFormSchema),
    defaultValues: addDriverFormSchema.cast({}),
  })
}
